import { connect } from "react-redux";
import { InAppTemplate } from "../../../shared/templates/inapp";
import CustomerDetails from "../../../views/app/customers/CustomerDetails";
import { appActions } from "../../../redux/actions/in-app";

const CustomerDetailsPage = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle=""
      childComponent={<CustomerDetails />}
    />
  );
};

const mapDispatchToProps = {
  getCustomerDetails: appActions.GetCustomerDetails,
  getCustomerOrders: appActions.GetCustomerOrders,
  toggleUser: appActions.ToggleUser,
};

const mapStateToProps = (state: any) => ({
  getCustomerDetailsRequest: state.allInAppReducers.getCustomerDetailsReducer,
  getCustomerOrdersRequest: state.allInAppReducers.getCustomerOrdersReducer,
  toggleUserRequest: state.allInAppReducers.toggleUserReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetailsPage);
